import {Injectable} from '@angular/core';
import {environment} from '../environments/environment';

@Injectable()
export class HelperService {
  constructor() {
  }

  public getApiBase(path: string = '') {
    return environment.apiBase + path;
  }

  public getAuthUrl() {
    return this.getApiBase('/jwt-auth/v1/token');
  }

  public getResetUrl() {
    return this.getApiBase('/manager/v2/password');
  }

  public getApiUrl(path: string = '') {
    return this.getApiBase('/wp/v2') + path;
  }

  public getManagerApiUrl(path: string = '') {
    return this.getApiBase('/manager/v2') + path;
  }
}
